module.exports = __webpack_public_path__ + "static/media/SatishRamchandani.6b2e0d62.svg";